import React from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import Scrollbars from "react-custom-scrollbars";
import I10n from '../../../features/i10n';
import { getQuestions } from '../../question-management/ducks';
import MsxIcons from "../../msx-icons";
import LoadingSpinner from "../../../atoms/loading";
import Skeleton from "../../../components/skeleton";
import Chip from "../../../components/chip";
import { getHMCCategories } from "../../get-hmc-categories/ducks";
import { appConfiguration } from "../../../utils/app-starter";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../../color-constants";

const Container = styled.div`
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 2em 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 16px 20px;
  align-items: stretch;
  border-top: 2px solid #cccc;
  background-color: #f4f4f4;
`;

const ContentWrapper = styled.div`
  flex: 1 1 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
`;

const Content = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: row;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const AnswerQuestionLabel = styled.span`
  font-size: 14px;
  margin-bottom: 10px;
`;

const LoadingWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  align-items: center;
  justify-content: center;
`;

const ActiveQuestionOptionsWrapper = styled(Content)`
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const AnswersHeaderWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
  overflow: hidden;
`;

const AnswerHeaderWrapper = styled.div`
  display: flex;
  cursor: pointer;
  max-width: ${props => props.width}%;
`;

const LabelAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const AnswerLabel = styled.span`
  font-size: 12px;
  ${props => props.highlighted && `color: ${SECONDARY_COLOR};color: var(--se-primary, ${SECONDARY_COLOR});`}
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const ArrowWrapper = styled.div`
  width: 24px;
  height: 24px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CategoriesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0px 10px 10px;
`;

const TopBorder = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 7px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-color: #EDEDED;
  transition: background-color 250ms;
`;

const CategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 30px 10px 20px 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0px 12px 20px -12px rgba(81, 81, 81, 0.36);
  transition: transform 250ms, margin-top 250ms, margin-bottom 250ms, box-shadow 250ms;
  :hover {
    box-shadow: 0px 20px 20px -20px rgba(81, 81, 81, 0.72);
    margin-top: -8px;
    margin-bottom: 18px;

    ${TopBorder} {
      background-color: ${SECONDARY_COLOR};
      background-color: var(--se-primary, ${SECONDARY_COLOR});
    }
  }

  align-items: center;
  min-width: 400px;
  max-width: 400px;
  width: 400px;
  @media (max-width: 500px) {
    min-width: unset;
    width: auto;
  }
`;

const ImageWithInfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const RecommendedCard = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 5px;
  background-color: ${SECONDARY_COLOR};
  background-color:  var(--se-primary, ${SECONDARY_COLOR});
  color: white !important;
  color: var(--se-primary-contrast, white) !important;
  border-top-left-radius: 8px;
`;

const RecommendedLabel = styled.span`
  font-weight: bold;
  font-size: 14px;
`;

const CategoryInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

const CategoryImage = styled.img`
  width: 40px;
  height: 40px;
`;

const CategoryTitle = styled.span`
  color: black;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;

const CategoryDescription = styled.span`
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
  font-size: 12px;
`;

const StartLabelWrapper = styled.div`
    margin-top: 10px;
    display: flex;
    align-self: flex-end;
`;

const StartLabel = styled.span`
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  font-size: 14px;

  ${CategoryWrapper}:hover & {
    text-decoration: underline;
  }
`;

const hmcQuestionsKey = 'HELP_ME_CHOOSE';

class ModalHelpMeChoose extends React.PureComponent {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      categories: [],
      questions: [],
      questionsWithAnswers: {},
      availableCriteria: {}
    };


  }

  _getPreviousQuestionsAnswers = (question) => {
    const questionsWithAnswers = this.state.questionsWithAnswers;
    if (questionsWithAnswers[question?.previousQuestionKey]) {
      return questionsWithAnswers[question?.previousQuestionKey];
    }
    return null;
  }

  _questionShouldBeActive = (question) => {
    const havePreviousTrigger = !!question?.previousQuestionKey && question.previousQuestionsTrigger?.length > 0;
    if (!havePreviousTrigger) {
      return true;
    }
    const previousQuestionsAnswers = this._getPreviousQuestionsAnswers(question) || [];
    const previousQuestionsTrigger = question.previousQuestionsTrigger || [];

    const answersAndTriggerIntersection = previousQuestionsTrigger.filter(value => previousQuestionsAnswers.includes(value));

    let shouldBeActive = answersAndTriggerIntersection.length > 0;

    return shouldBeActive;
  }

  getActiveQuestion() {
    let activeQuestion;
    const sortedQuestions = this.state.questions.sort((a, b) => a.order - b.order);
    sortedQuestions.forEach(question => {
      if (this._questionShouldBeActive(question)) {
        activeQuestion = question;
      }
    });

    return activeQuestion;
  }

  buildAvailableCriteria = (categories) => {
    const availableCriteria = {};
    for (const category of categories) {
      if (category.criteria && Object.entries(category.criteria).length > 0 && appConfiguration.technologies[category.variable.toLowerCase()]) {
        for (const [key, value] of Object.entries(category.criteria)) {
          if (availableCriteria[key] == null) {
            availableCriteria[key] = {};
          }
          availableCriteria[key][value] = true;
        }
      }
    }
    return availableCriteria;
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.getAggregatedQuestions(hmcQuestionsKey).then((payload) => {
      let questions = [];
      try {
        if (payload.aggregatedQuestions) {
          payload.aggregatedQuestions.forEach(category => {
            questions.push(...(category.questions || []));
          });
        }
        this.updateStateIfMounted({ questions });
      } catch (e) { }
    });
    this.loadCategories({});
  }

  loadCategories = (payload) => {
    this.props.getHMCCategories(payload).then((categories) => {
      this.updateStateIfMounted({ categories, availableCriteria: this.buildAvailableCriteria(categories) });
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted = (objectToAffect) => {
    if (this._isMounted) {
      return this.setState(objectToAffect);
    }
  }

  getQuestionMap = () => {
    const questionMap = {};
    for (const questionCategory of this.props.questions.aggregatedQuestions) {
      for (const question of questionCategory.questions) {
        questionMap[question.questionKey] = question;
      }
    }
    return questionMap;
  }

  buildCriteriaPayload = (questionsWithAnswers) => {
    const questionMap = this.getQuestionMap();
    const payload = {};
    for (const [key, answer] of Object.entries(questionsWithAnswers)) {
      payload[questionMap[key].criteria] = answer;
    }
    return payload;
  }

  get numberQuestionsAnswered() {
    return Object.keys(this.state.questionsWithAnswers).length;
  }


  clearEmptyAnswer = (questionsWithAnswers) => {
    const newQuestionsWithAnswer = { ...questionsWithAnswers };
    const keys = Object.keys(newQuestionsWithAnswer);
    for (let i = 0; i < keys.length; i++) {
      if (newQuestionsWithAnswer[keys[i]].length === 0) {
        delete newQuestionsWithAnswer[keys[i]];
      }
    }

    return newQuestionsWithAnswer;
  }


  onAnswerChanged = (question, value, status) => {
    let newQuestionsWithAnswer = { ...this.state.questionsWithAnswers };
    if (status === 'remove') {
      delete newQuestionsWithAnswer[question.questionKey];
    } else {
      newQuestionsWithAnswer[question.questionKey] = value;
    }

    this.updateStateIfMounted({ questionsWithAnswers: newQuestionsWithAnswer });
    this.loadCategories(this.buildCriteriaPayload(newQuestionsWithAnswer));
  }

  renderActiveQuestionOptions = (activeQuestion) => {
    if (activeQuestion) {
      const options = activeQuestion.options || [];
      return (options.filter((opt) => {
        return !!this.state.availableCriteria?.[activeQuestion.criteria]?.[opt.criteriaValue];
      }).map((opt, idx) => {
        return (<Chip
          key={idx}
          loading={false}
          disabled={this.props.hmcCategories.isLoading}
          selected={this.state.questionsWithAnswers[activeQuestion.questionKey] && this.state.questionsWithAnswers[activeQuestion.questionKey].includes(opt.criteriaValue)}
          value={I10n.getOrDefault(`answers.${opt.answerKey}.label`, opt.answer, 'data')}
          showCheck={true}
          showHint={false}
          onClick={() => {
            if (this.state.questionsWithAnswers[activeQuestion.questionKey] && this.state.questionsWithAnswers[activeQuestion.questionKey].includes(opt.criteriaValue)) {
              this.onAnswerChanged(activeQuestion, opt.criteriaValue, 'remove');
            } else {
              this.onAnswerChanged(activeQuestion, opt.criteriaValue, 'add');
            }
          }}>
        </Chip>);
      }));
    }

    return <></>;
  }


  getAnswerText = (options, criteriaValue) => {

    let optKey = 'default';
    for (const opt of options) {
      if (opt.criteriaValue === criteriaValue) {
        optKey = opt.answerKey
      }
    }

    return I10n.getOrDefault(`answers.${optKey}.label`, criteriaValue, 'data')
  }

  removeAnswersFromIndex = (index) => {
    const sortedQuestions = this.state.questions.sort((a, b) => a.order - b.order);
    let newQuestionsWithAnswer = { ...this.state.questionsWithAnswers };

    sortedQuestions.forEach((question, questionIndex) => {
      if (questionIndex >= index && this.state.questionsWithAnswers[question.questionKey]) {
        delete newQuestionsWithAnswer[question.questionKey];
      }
    });

    this.updateStateIfMounted({ questionsWithAnswers: newQuestionsWithAnswer });
    this.loadCategories(this.buildCriteriaPayload(newQuestionsWithAnswer));
  }

  renderAnswerHeader = () => {
    const sortedQuestions = this.state.questions.sort((a, b) => a.order - b.order);
    const numberQuestionsAnswered = Object.keys(this.state.questionsWithAnswers).length;

    return (<AnswersHeaderWrapper>
      {sortedQuestions.map((question, idx) => {
        if (this.state.questionsWithAnswers[question.questionKey] == null) {
          return (<React.Fragment key={idx}></React.Fragment>);
        }
        return (<AnswerHeaderWrapper key={idx} width={100.0 / numberQuestionsAnswered} onClick={() => {
          this.removeAnswersFromIndex(idx);
        }}>
          <LabelAndIconWrapper>
            <AnswerLabel highlighted={question.order === numberQuestionsAnswered}>{this.getAnswerText(question.options, this.state.questionsWithAnswers[question.questionKey])}</AnswerLabel>
            {question.order < numberQuestionsAnswered && <ArrowWrapper><MsxIcons name="right-arrow"></MsxIcons></ArrowWrapper>}
          </LabelAndIconWrapper>
        </AnswerHeaderWrapper>);
      })}

    </AnswersHeaderWrapper>);
  }

  renderCategories = () => {
    return (
      <CategoriesWrapper>
        {this.state.categories.map((cat, idx) => {
          const isRecommended = this.state.categories.length === 1;
          return (<CategoryWrapper recommended={isRecommended} key={idx} onClick={() => {
              this.props.onSelectCategory(cat.variable);
          }}>
            <TopBorder></TopBorder>
            {isRecommended && <RecommendedCard><RecommendedLabel>{I10n.get(`screen.accessorize_screen.device_with_recommended`)}</RecommendedLabel></RecommendedCard>}
            <ImageWithInfoWrapper>
              <CategoryImage src={cat.image}></CategoryImage>
              <CategoryInfoWrapper>
                <CategoryTitle>{I10n.getOrDefault(`hmc.category.${cat.variable.toLowerCase()}.title`, cat.title, 'data')}</CategoryTitle>
                <CategoryDescription>{I10n.getOrDefault(`hmc.category.${cat.variable.toLowerCase()}.description`, cat.description, 'data')}</CategoryDescription>
              </CategoryInfoWrapper>
            </ImageWithInfoWrapper>
            <StartLabelWrapper><StartLabel>{I10n.get('screen.start_configuration_screen.start_now')}</StartLabel></StartLabelWrapper>
          </CategoryWrapper>);
        })}
      </CategoriesWrapper>
    );
  }

  render = () => {
    const activeQuestion = this.getActiveQuestion();
    return (
      <Container>
        <Header>
        <TitleWrapper id="modal-helpMeChoose-titleWrapper">
          <Title>{activeQuestion ? I10n.getOrDefault(`questions.${activeQuestion.questionKey}.label`, activeQuestion.question, 'data') : I10n.get(`screen.start_configuration_screen.hmc.button`)}</Title>
          <CloseIcon onClick={(e) => {
            e.preventDefault();
            this.props.closeModal();
          }}>
            <MsxIcons name="close"></MsxIcons>
          </CloseIcon>
          </TitleWrapper>
        </Header>
        {this.props.questions.isLoading ? <LoadingWrapper><LoadingSpinner></LoadingSpinner></LoadingWrapper> :
          <Body>
            <Scrollbars>
              <ContentWrapper>
                {this.numberQuestionsAnswered > 0 && this.renderAnswerHeader()}
                <ActiveQuestionOptionsWrapper>
                  {this.renderActiveQuestionOptions(activeQuestion)}
                </ActiveQuestionOptionsWrapper>
                {this.numberQuestionsAnswered === 0 && <AnswerQuestionLabel>{I10n.get('help_me_choose.remove.modal.answer_question')}</AnswerQuestionLabel>}
                {(this.numberQuestionsAnswered === 0 || this.props.hmcCategories.isLoading) ? <>
                  <Skeleton nbCols={2} expand={false}></Skeleton>
                </> : <Content>
                  {this.renderCategories()}
                </Content>}
              </ContentWrapper>
            </Scrollbars>
          </Body>}
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    getAggregatedQuestions: (questionType) => dispatch(getQuestions(questionType)),
    getHMCCategories: (criteria) => dispatch(getHMCCategories(criteria))
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(ModalHelpMeChoose);
